<template>
  <div>
    <div class="head row">
      <h3 class="pl-3">Berichten</h3>
    </div>
    <div>
      <table class="table table-responsive table-hover">
        <thead>
          <tr>
            <th></th>
            <th>Van</th>
            <th>Onderwerp</th>
            <th>Datum</th>
            <th></th>
          </tr>
        </thead>
        <thead>
          <tr>
            <th></th>
            <th>
              <input
                type="text"
                @keyup="filter()"
                v-model="search.from_name"
                placeholder="Zoeken..."
                class="form-control"
              />
            </th>
            <th>
              <input
                type="text"
                @keyup="filter()"
                v-model="search.subject"
                placeholder="Zoeken..."
                class="form-control"
              />
            </th>
            <th>
              <input
                type="text"
                @keyup="filter()"
                v-model="search.body"
                placeholder="Zoeken..."
                class="form-control"
              />
            </th>
            <th></th>
          </tr>
        </thead>
        <thead></thead>
        <tbody>
          <tr v-for="(message, index) in messages" :key="index">
            <td>
              <div class="btn-group">
                <router-link
                  class="btn btn-dark btn-primary btn-sm"
                  v-bind:to="'/profile/' + userId + '/messages/' + message.id"
                >
                  <i class="fas fa-eye"></i>
                </router-link>
              </div>
            </td>
            <td>{{ message.from_name }}</td>
            <td>{{ message.subject }}</td>
            <td>{{ formatDate(message.created_at) }}</td>
            <td>
              <i
                v-if="message.is_read"
                class="fas fa-envelope-open fa-1x text-dark"
              ></i>
              <i v-else class="fas fa-envelope fa-1x text-dark"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "index",
  components: {},
  computed: {},
  data() {
    return {
      messages: [],
      userId: null,
      search: {},
    };
  },
  created() {
    this.$store.state.inner_sidebar = [];
    this.userId = this.$route.params.id;

    this.$store
      .dispatch("get", "/api/v1/messages/" + this.userId)
      .then((data) => {
        this.messages = data.data.data;
      })
      .catch((error) => {
        console.log(error.request);
      });
  },
  methods: {
    filter() {
      this.$store
        .dispatch("post", {
          details: { search: this.search },
          endpoint: "/api/v1/messages/filter",
        })
        .then((data) => {
          console.log(data.data);
          this.messages = data.data.data;
        })
        .catch((error) => {
          console.log(error.request);
        });
    },
    formatDate: function(date_in) {
      var date = new Date(date_in);
      var val = {
        d: date.getDate(),
        m: date.getMonth() + 1,
        yy: date
          .getFullYear()
          .toString()
          .substring(2),
        yyyy: date.getFullYear(),
        hh: date.getHours(),
        mm: date.getMinutes(),
        ss: date.getSeconds(),
      };
      val.dd = (val.d < 10 ? "0" : "") + val.d;
      val.mm = (val.m < 10 ? "0" : "") + val.m;
      return (
        val.dd +
        "-" +
        val.m +
        "-" +
        val.yyyy +
        " " +
        val.hh +
        ":" +
        val.mm +
        ":" +
        val.ss
      );
    },
  },
};
</script>

<style lang="css" scoped></style>
